import { Button } from "primereact/button";
import React from "react";

const GlobalButton = ({
  value,
  isRounded = false,
  label = "",
  buttonClassName,
  parentClassName,
  onClick,
  style,
  children,
  disabled,
  severity,
  icon,
  isText,
  hidden,
  loading,
  isPrimary = false,
  iconPos,
  isSecondary = false,
}) => {
  const primaryClass =
    "bg-primary-primaryYellow hover:bg-primary-primaryYellowDark border border-primary-primaryYellow text-secondary-purpleGray font-bold text-sm";

  const secondaryClass =
    "bg-white hover:bg-gray-100 border border-primary-primaryYellow text-secondary-purpleGray font-bold text-sm";

  const variantClass = isPrimary
    ? primaryClass
    : isSecondary
      ? secondaryClass
      : "";

  return (
    <div className={parentClassName}>
      <Button
        text={isText}
        icon={icon}
        iconPos={iconPos}
        hidden={hidden}
        disabled={disabled}
        loading={loading}
        rounded={isRounded}
        severity={severity}
        value={value}
        label={label}
        className={`${variantClass} ${buttonClassName ?? ""} gap-2 p-2 font-montserrat ${
          !isText && "shadow-md"
        } text-center ${disabled && "bg-gray-300"}`}
        size="small"
        onClick={onClick}
        style={style}
      >
        {children}
      </Button>
    </div>
  );
};

export default GlobalButton;
